import React, {useState} from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";


{/* <Route path="/" element={<HaversineCalculator />} />
            <Route path="/bounding-box" element={<BoundingBoxCalculator />} />
            <Route path="/great-circle" element={<GreatCircleRoute />} />
            <Route path="/mid-point" element={<MidPointCalculator />} />
            <Route path="/vincenty-calculator" element={<VincentyCalculator />} />
            <Route path="/view-map" element={<ViewMap />} /> */}

const Sidebar = () => {

  const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);

  // Close sidebar on mobile when a link is clicked
  const closeSidebar = () => {
    if (window.innerWidth < 768) {
      setIsOpen(false);
    }
  };

  return (

    <>
       {/* Toggle Button for Mobile */}
       <button className="menu-button" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      {/* Sidebar */}

      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <h1 className="project-title">IsHoncha</h1>
      <Link to="/" className="sidebar-btn" onClick={closeSidebar}>Haversine Distance</Link>
      <Link to="/bounding-box" className="sidebar-btn" onClick={closeSidebar}>Bounding Box</Link>
      <Link to="/great-circle" className="sidebar-btn" onClick={closeSidebar}>Great Circle Route</Link>
      <Link to="mid-point" className="sidebar-btn" onClick={closeSidebar}>Mid Point cal</Link>
      <Link to="/vincenty-calculator" className="sidebar-btn" onClick={closeSidebar}>Vincenty Calculator</Link>
      </div>
    </>
  );
};

export default Sidebar;